import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { parseString } from "xml2js";
@Injectable()
export class HttpService {
	constructor(private http: HttpClient) {}

	public get(path:string, type?: string){
		const options:any = type === undefined
		  ? this.createOptionFor(path) 
		  : this.createOption(type)
	
		return new Promise((resolve, reject) => {
		   this.http.get(path, options)
			   .subscribe(res => resolve(res), error => reject(error));
		});
	  }
	public post(path: string, body: any, data: any) {
		return new Promise((resolve, reject) => {
			this.http.post(path, body, data).subscribe(
				(res) => resolve(res),
				(error) => reject(error)
			);
		});
	}

	public ajax(
		method: string,
		path: string,
		body: any = null,
		data: any = null
	) {
		let headers = new HttpHeaders({
			"Content-Type": "application/x-www-form-urlencoded"
		});
		//headers.append('Content-length', body.toString().length);
	
		if (method.toLowerCase() === "post") {
			return new Promise((resolve, reject) => {
				this.http.post(path, body, { headers: headers, observe:'response', responseType: 'text' }).subscribe(
					(res) => resolve(res),
					(error) => reject(error)
				);
			});
		}
		return new Promise((resolve, reject) => {
			this.http.get(path + "?" + body, { headers: headers,  observe:'response', responseType: 'text' }).subscribe(
				(res) => resolve(res),
				(error) => reject(error)
			);
		});
	}

	public ajaxXAPI(
		method: string,
		path: string,
		body: any = null,
		data: any = null
	) {
		let headers = new HttpHeaders({
			"Content-Type": data["content-type"],
			"Authorization": data.Authorization,
			"X-Experience-API-Version": data["X-Experience-API-Version"]
		});

		// headers.append("Access-Control-Allow-Origin", "*");
		//headers.append('Content-length', body.toString().length);
		if (method.toLowerCase() === "post") {
			return new Promise((resolve, reject) => {
				console.log("body :", body);
				this.http.post(path, body, { headers: headers, observe: 'response', responseType: 'text' }).subscribe(
					(res) => resolve(res),
					(error) => reject(error)
				);
			});
		} else if (method.toLowerCase() === "put") {
			return new Promise((resolve, reject) => {
				console.log("body :", body);
				this.http.put(path, body, { headers: headers, observe: 'response', responseType: 'text' }).subscribe(
					(res) => resolve(res),
					(error) => reject(error)
				);
			});
		}
		return new Promise((resolve, reject) => {
			this.http.get(path, { headers: headers, observe: 'response' , responseType: 'text'}).subscribe(
				(res) => resolve(res),
				(error) => {
					console.log("error : ", error);
					if (error && error.statusText && error.statusText == "Not Found") {
						resolve(null);
					} else if (error.statusText.toLowerCase() == "ok") {
						resolve(null);
					} else {
						reject(error);
					}
				}
			);
		});
	}

	public getXmlData(path: string) {
		return new Promise((resolve, reject) => {
			return this.http.get(path, this.createOptionFor(path)).toPromise()
			.then((res: any) => {
					if (res) {
						resolve(new DOMParser().parseFromString(res, "text/xml"));
					}
				})
				.catch((error) => reject(error));
		});
	}
	public getXMLInJson(path: string) {
		return new Promise((resolve, reject) => {
			return this.get(path)
				.then((res: any) => {
					if (res.ok) {
						parseString(res, function (err, result) {
							resolve(result);
						});
					}
				})
				.catch((error) => reject(error));
		});
	}

	private createOptionFor(path: string):any {
		const parts:Array<string> = path.split(".");
		const ext:string = parts.pop();
		const type:string = ext === "json" ? "response" : ext;
		return this.createOption(type);
	  }
	
	  private createOption(type: string): any {
		let responseType: string = ""
		let contentType: string = ""
	
		switch(type.toLowerCase()) {
		  case "xml":
			responseType = "text"
			contentType = "text/xml"
			break
		  case "html":
			responseType = "text"
			contentType = "text/html"
			break
		  case "css":
			responseType = "text"
			contentType = "text/css"
			break
		  case "text":
			responseType = "text"
			contentType = "text/plain; charset=utf-8"
			break
		  default: 
			return { observe: "response" }
		}
	
		return { headers: new HttpHeaders({ 'Content-Type': contentType }), responseType };
	  }
}
